angular.module('unergie.main')
.controller('csrB2cHomeCtrl', ($q, $scope, NgTableParams, AlertManager, AuthService, BoFeaturesService, ModalService, ApiAdmin,
    ErrorCatcher, JiraConstants, JiraService, AccountService, DataAccess, DataAccessSearch) => {
    const auth = AuthService.getAuth()
    let availableAssignees = []

    $scope.issues = {
        assigned: null,
        unassigned: null,
        postponed: null,
    }
    $scope.totalCount = {}
    $scope.JiraConstants = JiraConstants
    $scope.jira_status_mapping = $q.defer()
    $scope.epic_mapping = $q.defer()
    $scope.isManager = BoFeaturesService.isFeatureOn('canUpdateCsrIssueAssignee')
    $scope.assignedTitle = $scope.isManager ? 'Tickets assignés' : 'Mes tickets'
    $scope.postponedTitle = $scope.isManager ? 'Tickets en attente' : 'Mes tickets en attente'
    $scope.updateReminderFields = {
        newReminder: {
            label: `Nouveau rappel`,
            type: 'datepicker',
            required: true,
        },
    }

    const setDropdownStatusMappings = (issues) => {
        $scope.jira_status_mapping.resolve(_.uniqBy([{ id: '', title: 'Tous' }].concat(_.map(issues, (issue) => ({
            id: issue.fields.status.id,
            title: issue.fields.status.name,
        }))), 'id'))
    }
    const setDropdownEpicsMappings = (issues) => {
        $scope.epic_mapping.resolve(_.uniqBy([{ id: '', title: 'Tous' }].concat(_.map(issues, (issue) => ({
            id: issue.fields.epicLink,
            title: ($scope.projectEpics[issue.fields.epicLink] && $scope.projectEpics[issue.fields.epicLink].fields.epicName) || issue.fields.epicLink,
        }))), 'id'))
    }
    const isPostponed = (reminder) => reminder && moment().isBefore(reminder)
    const getTableToRender = (reminder, assigneeBO) => {
        if (isPostponed(reminder)) {
            return 'postponed'
        }
        if (assigneeBO) {
            return 'assigned'
        }
        return 'unassigned'
    }

    const refreshIssues = (type) => (params) => {
        $scope.issues[type].refreshing = true

        const jiraParams = _.assign({}, params)

        jiraParams.filter = () => _.assign({}, params.filter())

        let getIssues
        switch (type) {
            case 'unassigned':
                getIssues = JiraService.getUnassigned
                break
            case 'assigned':
                getIssues = JiraService.getAssigned
                break
            case 'postponed':
                getIssues = JiraService.getPostponed
                break
            default:
        }

        return getIssues(jiraParams, 'support,exploit').$promise
        .then((response) => {
            $scope.totalCount[type] = `${response.results.issues.length}${response.results.issues.length === jiraParams.count() ? '+' : ''}`

            $scope.issues[type].data = _.reduce(response.results.issues, (issues, issue) => {
                const linkRegex = /((?:(?:https?|ftp|file):\/\/|www\.|ftp\.)(?:\([-A-Z0-9+&@#/%=~_|$?!:,.]*\)|[-A-Z0-9+&@#/%=~_|$?!:,.])*(?:\([-A-Z0-9+&@#/%=~_|$?!:,.]*\)|[A-Z0-9+&@#/%=~_|$]))/gmi
                const description = issue.fields.description.replace(linkRegex, '<a href="$1" target="_blank">$1</a>')

                issues.push({
                    issueIcon: issue.fields.issuetype.iconUrl,
                    key: issue.key,
                    projectKey: issue.fields.project.key,
                    requestType: issue.fields.requestType && issue.fields.requestType.requestType ?
                        issue.fields.requestType.requestType.name : '',
                    created: moment(issue.fields.created).format('DD/MM/YYYY HH:mm'),
                    updated: moment(issue.fields.updated).format('DD/MM/YYYY HH:mm'),
                    idContract: issue.fields.idContract,
                    summary: issue.fields.summary,
                    description,
                    status: issue.fields.status.name,
                    statusId: issue.fields.status.id,
                    initiator: issue.fields.initiator,
                    simpleInitiator: issue.fields.initiator && issue.fields.initiator.split('@')[0],
                    assigneeBO: issue.fields.assigneeBO,
                    idPrm: issue.fields.idPrm,
                    epicLink: issue.fields.epicLink,
                    epicLinkLabel: ($scope.projectEpics[issue.fields.epicLink] && $scope.projectEpics[issue.fields.epicLink].fields.epicName) || issue.fields.epicLink,
                    updateAssigneeFields: {
                        newAssignee: {
                            label: `Nouveau responsable`,
                            type: 'select',
                            required: true,
                            enum: availableAssignees.filter((assignee) => assignee !== issue.fields.assigneeBO).map((user) => ({ label: user, value: user })),
                        },
                    },
                    reminder: issue.fields.reminder,
                    sensitive: issue.fields.sensitive,
                    expired: moment(issue.fields.limitDate).isBefore(moment()),
                })

                return issues
            }, [])

            $scope.issues[type].displayedCount = $scope.issues[type].data.length

            setDropdownStatusMappings(response.results.issues)
            setDropdownEpicsMappings(response.results.issues)

            return $scope.issues[type].data
        }).catch((err) => {
            $scope.issues[type].data = null
            console.error(err)
            return AlertManager.error('Une erreur est intervenue lors de l’appel a JIRA', 5000)
        }).finally(() => {
            $scope.issues[type].refreshing = false
        })
    }

    $scope.renderTable = (type) => {
        $scope.issues[type] = new NgTableParams({
            count: ($scope.issues[type] != null ? $scope.issues[type].count() : undefined) || 12,
            filter: ($scope.issues[type] != null ? $scope.issues[type].filter() : undefined) || {},
            sorting: ($scope.issues[type] != null ? $scope.issues[type].sorting() : undefined) || { reminder: 'asc', sensitive: 'asc', updated: 'asc' },
        }, {
            counts: [12, 25, 50, 100],
            getData: refreshIssues(type),
        })
    }

    $scope.expandIssue = (datum) => {
        if (datum) {
            if (!datum.expanded) {
                datum.refreshing = true
                datum.expanded = !datum.expanded
                return ApiAdmin.getJiraStatusHistoryAndPublicComments({ idIssue: datum.key }).$promise
                .then((jiraResponse) => {
                    datum.history = jiraResponse.history

                    const commentsEnhanced = _.reduce(jiraResponse.publicComments, (comments, comment) => {
                        if (comment.body.indexOf(': Statut modifié par') === -1) {
                            let name = comment.author.displayName
                            let displayedBody = JiraService.attachmentCommentCleaner(comment.body)

                            if (name === 'Développeurs ') {
                                const nameMatch = displayedBody.match(/(.*?) : /)

                                name = (nameMatch && nameMatch[1]) || name
                                displayedBody = (nameMatch && displayedBody.replace(nameMatch[0], '')) || displayedBody
                            }

                            comments.push(_.assign({}, comment, {
                                displayedBody,
                                name,
                            }))
                        }

                        return comments
                    }, [])

                    datum.comments = _.orderBy(commentsEnhanced, 'created', 'desc')
                    datum.attachments = _.orderBy(jiraResponse.attachments.map((attachment) => {
                        return _.assign({}, attachment, {
                            displayedFilename: attachment.filename.replace(/^(public_|internal_)/, ''),
                            isInternal: !attachment.filename.startsWith('public_'),
                        })
                    }), 'created', 'desc')

                    return AccountService.fetchAccountForContract(datum.idContract, (error, account) => {
                        if (error) {
                            datum.account = {}
                            datum.refreshing = false
                            console.error(error)
                            return AlertManager.error('Une erreur est intervenue lors de la récupération du compte', 5000)
                        }
                        datum.account = account
                        datum.refreshing = false
                    })
                })
            }
            datum.expanded = !datum.expanded
        }
    }

    $scope.openJiraCommentsModal = (event, issue) => {
        event.preventDefault()
        event.stopPropagation()
        ModalService.openModal({ type: 'jiraCommentsModal', size: 'lg' }, { idJira: issue.key, issueType: 'b2c', readOnly: false })
    }

    $scope.getChangeStatusConfirm = (event, issue) => {
        issue.fetchingStatuses = true
        return ApiAdmin.getIssueTransitions({ idIssue: issue.key, issueType: 'b2c' }).$promise.then((transitions) => {
            const transitionsFiltered = _.filter(transitions.transitions || [], (t) => t.to.name !== issue.status)
            if (transitionsFiltered.length) {
                issue.transitions = transitionsFiltered
                issue.changeStatusFields = {
                    newStatus: {
                        label: 'Nouveau statut',
                        type: 'select',
                        required: true,
                        enum: _.map(transitionsFiltered, (t) => ({ value: t.id, label: t.to.name })),
                    },
                    newStatusComment: {
                        label: 'Commentaire',
                        type: 'text',
                    },
                }
            } else {
                issue.changeStatusFields = {
                    label: {
                        label: 'Vous ne pouvez pas modifier le statut de ce ticket.',
                        type: 'label',
                    },
                }
            }
        })
        .catch(ErrorCatcher)
        .finally(() => {
            issue.fetchingStatuses = false
        })
    }

    $scope.changeIssueStatus = (issue, isAssigned) => {
        issue.modifyingStatus = true
        const transitionLabel = _.find(issue.transitions, { id: issue.newStatus }).name
        const comment = `Statut modifié par ${auth.user} => [${transitionLabel}]${issue.newStatusComment ? `, commentaire: "${issue.newStatusComment}"` : ''}`
        return ApiAdmin.performIssueTransition({ idIssue: issue.key, issueType: 'b2c' }, { id: issue.newStatus, comment }).$promise.then(() => {
            AlertManager.success('Statut modifié')

            if (isAssigned) {
                return isPostponed(issue.reminder) ? $scope.renderTable('postponed') : $scope.renderTable('assigned')
            }

            return $scope.renderTable('unassigned')
        })
        .catch(ErrorCatcher)
        .finally(() => {
            issue.modifyingStatus = false
        })
    }

    $scope.selfAssign = (event, issue) => {
        event.preventDefault()
        event.stopPropagation()

        const payload = {}

        if (issue.statusId === '10593') { // Retour demandeur
            payload.initiator = AuthService.getAuth().user
        } else {
            payload.assigneeBO = AuthService.getAuth().user
        }

        return ApiAdmin.updateJiraIssue({ idIssue: issue.key, projectKey: issue.projectKey }, payload).$promise
        .then(() => {
            if (isPostponed(issue.reminder)) {
                $scope.renderTable('postponed')
            } else {
                $scope.renderTable('assigned')
            }

            $scope.renderTable('unassigned')
        })
    }

    $scope.updateIssueAssignee = ({ key: idIssue, projectKey, newAssignee: assigneeBO, reminder }) => {
        return ApiAdmin.updateJiraIssue({ idIssue, projectKey }, { assigneeBO }).$promise
        .then(() => {
            $scope.renderTable(getTableToRender(reminder, assigneeBO))()

            AlertManager.success('Responsable modifié')
        }).catch(ErrorCatcher)
    }

    $scope.updateIssueReminder = ({ key: idIssue, projectKey, newReminder: reminder, reminder: oldReminder, assigneeBO }) => {
        return ApiAdmin.updateJiraIssue({ idIssue, projectKey }, { reminder }).$promise
        .then(() => {
            $scope.renderTable(getTableToRender(reminder, assigneeBO))
            $scope.renderTable(getTableToRender(oldReminder, assigneeBO))

            AlertManager.success('Date de rappel modifié')
        }).catch(ErrorCatcher)
    }

    const init = () => {
        $scope.initializing = true

        return JiraService.getEpics()
        .then((epics) => {
            $scope.projectEpics = epics

            $scope.renderTable('assigned')
            $scope.renderTable('unassigned')
            $scope.renderTable('postponed')

            return DataAccess.getCsrAvailableAssignees().$promise
        }).then((csrAvailableAssignees) => {
            availableAssignees = csrAvailableAssignees

            return DataAccessSearch({ columns: ['affectation_user'] }).searchPaginated({ resource: 'contracts-needing-attention', id_grd_contract: 'GRD-F052' }).$promise
        }).then((actiFollows) => {
            $scope.actiFollowUnassigned = _.filter(actiFollows.results, (actiFollow) => !auth.user).length
            $scope.actiFollowMines = _.filter(actiFollows.results, (actiFollow) => auth.user === actiFollow.affectation_user).length

            return ApiAdmin.fetchTicketsCounts().$promise
        }).then((zendeskCounts) => {
            $scope.zendeskUnassigned = zendeskCounts.tickets
            $scope.zendeskUnassignedUrgent = zendeskCounts.urgentTickets

            return ApiAdmin.userTicketsCounts({ userId: auth.accountId }).$promise
        }).then((zendeskCounts) => {
            $scope.zendeskMines = zendeskCounts.tickets
            $scope.zendeskMinesUrgent = zendeskCounts.urgentTickets
        }).finally(() => {
            $scope.initializing = false
        })
    }

    init()
})
